import {makeUpdateRefundProcedure} from 'main/factories/usecases/private/refund/request/update-procedure';
import {UpdateRefundProcedureParams} from 'domain/usecases/private/refund/request/update-procedure';

export async function updateProcedure(params: UpdateRefundProcedureParams) {
	const updateRefundProcedure = makeUpdateRefundProcedure();
	return updateRefundProcedure.update(params);
}
